// extracted by mini-css-extract-plugin
export default {"VideoPlayer":"VideoPlayer_VideoPlayer__6mGR2","Hidden":"VideoPlayer_Hidden__ZApwF"};